/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import navbarSearchAndPinList from '@/layouts/components/navbarSearchAndPinList';
import themeConfig from '@/../themeConfig.js';
import colors from '@/../themeConfig.js';
import Vue from 'vue';
import { MFA_TYPE } from '../constants';
// import router from '../router';
let debugConsole = false;

const mutations = {
  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  UPDATE_SIDEBAR_WIDTH(state, width) {
    state.sidebarWidth = width;
  },
  UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
    state.sidebarItemsMin = val;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
    state.isSidebarActive = value;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_BREAKPOINT(state, val) {
    state.breakpoint = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_USER_ROLE(state, val) {
    state.userRole = val;
    localStorage.setItem('userRole', val);
  },
  // UPDATE_STATUS_CHAT(state, value) {
  //     state.AppActiveUser.status = value;
  // },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },

  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList.data.findIndex(
      (item) => item.index == payload.index
    );

    // update the main list
    state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList.data[index]);
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex(
        (item) => item.index == payload.index
      );

      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // The Navbar
  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false;
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true;
    });
    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

  //
  // TripleA code
  //

  SET_NEXT_ROUTE_PATH(state, nextPath) {
    state.nextPath = nextPath;
  },
  ADD_NEW_ACCOUNT(state, newAccount) {
    if (!state.accounts) {
      state.accounts = [];
    }
    state.accounts.push(newAccount);
  },
  UPDATE_ACCOUNT_INFO(state, account) {
    for (let i = 0; i < (state.accounts || []).length; ++i) {
      if (state.accounts[i].apiId === account.apiId) {
        Object.assign(state.accounts[i], account);
        break;
      }
    }
  },
  /**
   * Update the dashboard's active account.
   */
  SET_ACTIVE_ACCOUNT(state, apiId) {
    for (let i = 0; i < (state.accounts || []).length; ++i) {
      if (state.accounts[i].apiId === apiId) {
        if (!state.accounts[i].active) {
          // state.accounts[i].active = true;
          Vue.set(state.accounts, i, { ...state.accounts[i], active: true });
          if (this.debugConsole)
            console.log(
              'Active account is now ' + apiId,
              state.accounts[i].name,
              state.accounts[i]
            );
        }
      } else {
        state.accounts[i].active = false;
      }
    }

    state.sidebarUpdateCounter = (state.sidebarUpdateCounter + 1) % 99999;
  },
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts || [];
    state.sidebarUpdateCounter = (state.sidebarUpdateCounter + 1) % 99999;
    //console.debug('INC sidebar counter: ' + state.sidebarUpdateCounter);
  },

  UPDATE_ACCOUNT_ADDRESSES(state, { apiId, metaAddress, addresses }) {
    for (let i = 0; i < (state.accounts || []).length; ++i) {
      if (state.accounts[i].apiId === apiId) {
        //console.debug('UPDATE_ACCOUNT_TRANSACTIONS >> found matching account for apiId, account is : ', state.accounts[i]);

        // state.accounts[i].transactions = transactions;
        Vue.set(state.accounts[i], 'addresses', addresses);
        Vue.set(state.accounts[i], 'metaAddress', metaAddress);

        // let cleanedTransactions = (transactions || [])
        //   .sort((a, b) => {
        //     return a.time - b.time;
        //   });
        // Vue.set(state.accounts[i], 'cleanedTransactions', cleanedTransactions);

        break;
      }
    }
  },
  UPDATE_ACCOUNT_ADDRESSES_COUNT(state, { apiId, addressesCount }) {
    for (let i = 0; i < (state.accounts || []).length; ++i) {
      if (state.accounts[i].apiId === apiId) {
        // console.debug('UPDATE_ACCOUNT_TRANSACTION_COUNTS >> found matching account for apiId, account is : ', state.accounts[i]);
        Vue.set(state.accounts[i], 'addressesCount', addressesCount);
        break;
      }
    }
  },

  UPDATE_ACCOUNT_TRANSACTIONS(state, { apiId, metaTransaction, transactions }) {
    //console.debug('UPDATE_ACCOUNT_TRANSACTIONS: received ' + transactions.length + ' transactions for api id ' + apiId);

    for (let i = 0; i < (state.accounts || []).length; ++i) {
      if (state.accounts[i].apiId === apiId) {
        //console.debug('UPDATE_ACCOUNT_TRANSACTIONS >> found matching account for apiId, account is : ', state.accounts[i]);

        // state.accounts[i].transactions = transactions;
        Vue.set(state.accounts[i], 'transactions', transactions);
        Vue.set(state.accounts[i], 'metaTransaction', metaTransaction);

        let cleanedTransactions = (transactions || []).sort((a, b) => {
          return a.time - b.time;
        });
        Vue.set(state.accounts[i], 'cleanedTransactions', cleanedTransactions);

        break;
      }
    }
  },
  UPDATE_ACCOUNT_TRANSACTION_COUNTS(state, { apiId, transactionCounts }) {
    // console.debug('UPDATE_ACCOUNT_TRANSACTIONS: received ' + transactionCounts.length + ' transaction counts for api id ' + apiId);

    for (let i = 0; i < (state.accounts || []).length; ++i) {
      if (state.accounts[i].apiId === apiId) {
        // console.debug('UPDATE_ACCOUNT_TRANSACTION_COUNTS >> found matching account for apiId, account is : ', state.accounts[i]);
        Vue.set(state.accounts[i], 'transactionCounts', transactionCounts);
        break;
      }
    }
  },
  UPDATE_ACCOUNT_PAYOUTS(state, { apiId, payouts }) {
    // console.debug('UPDATE_ACCOUNT_PAYOUTS: received ' + payouts.length + ' payouts for api id ' + apiId, payouts);

    for (let i = 0; i < (state.accounts || []).length; ++i) {
      if (state.accounts[i].apiId === apiId) {
        // console.debug('UPDATE_ACCOUNT_PAYOUTS >> found matching account for apiId, account is : ', state.accounts[i]);
        Vue.set(state.accounts[i], 'payouts', payouts);
        break;
      }
    }
  },

  UPDATE_FIAT_PAYOUT_BALANCES(state, balances) {
    state.fiatPayoutBalances = balances;
  },
  UPDATE_FIAT_PAYOUTS(state, { data, pagination }) {
   
    const specialCases = [
      {
        merchant_key: 'mkey-cl47v7wb00000xv6m72j4bqnw', // Alex staging merchant
        transaction_ids: [
          '8238198b-b9a0-497a-bc8f-7f578f764198',
          'a92e4267-febb-4f26-a950-6deaa1c9d702',
          'b6122ca4-4402-4ece-8b59-656bdc28ba9d',
        ],
      },
      {
        merchant_key: 'mkey-clqm57smt0000c0dj7pw7e6sa', // Aspire
        transaction_ids: [
          '523dd0bd-2c2e-4d1a-8ac1-dba210498a29',
          '94282e67-3deb-4a9e-ae3a-1134217973ce',
          'a2d55d21-6cb0-46b6-8bb0-9c6d761f6438',
        ],
      },
    ];

    const findMerchant = specialCases.find(
      (item) => item.merchant_key === state.activeMerchant.merchant_key
    );

    if (findMerchant) {
      // filter out the unwanted transactions
      data = data && data.filter(item => !findMerchant.transaction_ids.includes(item.id));
    }

    state.fiatPayoutList = {
      data: data ? data : [],
      pagination: pagination
        ? pagination
        : {
            page: 1,
            perPage: 100,
            total: 0,
          },
    };
  },
  LOGIN_USER_ACCOUNT(state, userAccount) {
    state.activeUser = Object.assign({}, state.activeUser, userAccount);
  },
  LOGOUT_USER_ACCOUNT(state) {
    state.accounts = [];
    state.activeUser = null;
    state.merchants = [];
    state.apiCredentials = null;

    state.currentActiveEntityAdminData = {}; //entity admin refers to the dashboard users
    state.permissionGroup = [];
    state.entityAdminList = [];
    state.isAdmin = false;

    state.payoutList = [];

    state.merchantPayouts = [];

    state.selectedPayout = null;
    state.payoutMetaData = null;

    state.localCurrencyTxn = {};
    state.localCurrencyTxnCounts = [];

    state.refundList = [];
    state.selectedRefund = null;
    state.refundMetaData = null;

    state.activeMerchant = null;

    state.approvers = [];
    state.approvalTotal = 0;

    state.deposits = [];
    state.depositMetaData = null;
    state.otpKey = null;
    state.otpValue = null;
    state.isSidebarActive = false;
    state.breakpoint = null;
    state.sidebarWidth = 'default';
    state.reduceButton = themeConfig.sidebarCollapsed;
    state.bodyOverlay = false;
    state.sidebarItemsMin = false;
    state.theme = themeConfig.theme || 'light';
    state.navbarSearchAndPinList = navbarSearchAndPinList;
    state.sidebarUpdateCounter = 0;

    state.nextPath = '';

    state.activeMerchant = null;
    state.themePrimaryColor = colors.primary;

    state.starredPages = navbarSearchAndPinList.data.filter(
      (page) => page.highlightAction
    );
    state.userRole = null;

    state.windowWidth = null;

    state.selectedTransaction = null;
    state.isSignUp = false;

    state.popupDisplayCounter = 0;
    state.disableRefunds = false;
    state.selectedAddress = null;
    state.customInfo = null;

    state.resetPassword = false;
    state.timezone = '';

    state.searchResult = [];

    state.fiatPayoutBalances = [];
    state.merchantBankAccountDetails = null;
    state.merchantProfileDetails = null;
    state.exchangeRate = [];

    state.merchantExchangeRate = {};
    state.fiatPayoutMetaData = null;

    state.associatedPaymentDetails = null;
    state.entityAdmin2FAType = MFA_TYPE.EMAIL;
  },
  UPDATE_USER_PROFILE(state, userAccount) {
    //console.debug('UPDATE_USER_PROFILE: ', state.activeUser);

    state.activeUser = {
      ...state.activeUser,
      firstName: userAccount.firstName,
      lastName: userAccount.lastName,
      country: userAccount.country,
      mobile: userAccount.mobile,
    };

    //console.debug('UPDATE_USER_PROFILE: after update: ', state.activeUser);
  },

  UPDATE_SELECTED_TRANSACTION(state, val) {
    if (debugConsole) console.log('Value in update Selected transaction', val);
    state.selectedTransaction = val;
  },
  UPDATE_SELECTED_TRANSACTION_EXTRA_INFO(state, transaction) {
    // state.selectedTransaction = Object.assign({},state.selectedTransaction, transaction)
    Vue.set(
      state.selectedTransaction,
      'address_metadata',
      transaction.address_metadata
    );
  },

  GO_TO_SIGN_UP(state, val) {
    state.isSignUp = val;
  },

  UPDATE_POPUP_DISPLAY_COUNTER(state) {
    state.popupDisplayCounter += 1;
  },
  UPDATE_SELECTED_ADDRESS(state, val) {
    // console.log("Selected Address value", val);
    state.selectedAddress = val;
  },
  UPDATE_SELECTED_ADDRESS_EXTRA_INFO(state, payload) {
    // let obj = {
    //   payment_source: payload.address_metadata.payment_source,
    //   crypto_address_data : payload.address_metadata.crypto_address_data,
    //   txs: payload.address_metadata.txs,
    //   api_id : payload.address_metadata.api_id,
    //   refunds : payload.address_metadata.refunds,
    //   payer : payload.address_metadata.payer,
    // }
    // Vue.set(state.selectedAddress,'address_metadata',obj)
    state.selectedAddress = payload;
  },

  UPDATE_SEARCH_RESULT(state, payload) {
    state.searchResult = payload;
  },

  SET_MERCHANTS(state, merchants) {
    state.merchants =
      merchants.sort((a, b) => (a.merchant_name > b.merchant_name ? 1 : -1)) ||
      [];
  },

  SET_API_CREDENTIALS(state, apiCredentials) {
    state.apiCredentials = apiCredentials;
  },

  SAVE_NEW_CUSTOM_INFO(state, { newCustomInfo, merchantKey }) {
    if (debugConsole)
      console.debug(
        'New Custom Info inside save new custom info into active Merchant',
        newCustomInfo
      );

    let activeMerchant = state.merchants.find(
      (merchant) => merchant.merchant_key === merchantKey
    );
    activeMerchant.hosted_page = newCustomInfo;
  },
  RESET_PASSWORD(state, val) {
    state.resetPassword = val;
  },

  UPDATE_TIMEZONE(state, val) {
    state.timezone = val;
  },

  UPDATE_REFUND_VALUE(state, val) {
    state.refundValue = val;
  },

  UPDATE_PAYOUT_LIST(state, val) {
    state.payoutList = val;
  },

  UPDATE_MERCHANT_BANK_ACCOUNT(state, val) {
    state.merchantBankAccountDetails = val;
  },

  UPDATE_MERCHANT_PROFILE_DETAILS(state, val) {
    state.merchantProfileDetails = val;
  },

  UPDATE_EXCHANGE_RATE(state, val) {
    state.exchangeRate = val;
  },

  UPDATE_MERCHANT_PAYOUTS(state, val) {
    let newVal = val;
    for (let i = 0; i < newVal.length; i++) {
      if (newVal[i].type === 'merchant') {
        newVal[i].type = 'withdraw';
      }
    }
    state.merchantPayouts = newVal;
  },

  UPDATE_MERCHANT_EXCHANGE_RATE(state, val) {
    state.merchantExchangeRate = val;
  },

  //FOR ZEN PAYOUT
  UPDATE_SELECTED_PAYOUT(state, val) {
    state.selectedPayout = val;
  },

  UPDATE_PAYOUT_META_DATA(state, val) {
    state.payoutMetaData = val;
  },

  //for dashboard subaccounts and permissions
  UPDATE_CURRENT_ACTIVE_ENTITY_ADMIN(state, val) {
    state.currentActiveEntityAdminData = val; // the key or property will follow what backend provides.
  },

  UPDATE_ENTITY_ADMIN_LIST(state, val) {
    state.entityAdminList = val;
  },

  UPDATE_PERMISSION_GROUP(state, val) {
    state.permissionGroup = val;
  },

  UPDATE_IS_ADMIN(state, val) {
    state.isAdmin = val;
  },
  //*for dashboard subaccounts and permissions*

  UPDATE_LOCAL_CURRENCY_TXN(state, val) {
    state.localCurrencyTxn = val;
  },

  UPDATE_LOCAL_CURRENCY_TXN_COUNTS(state, val) {
    state.localCurrencyTxnCounts = val;
  },

  UPDATE_REFUND_LIST(state, val) {
    state.refundList = val;
  },

  UPDATE_SELECTED_REFUND(state, val) {
    state.selectedRefund = val;
  },

  UPDATE_REFUND_META_DATA(state, val) {
    state.refundMetaData = val;
  },

  UPDATE_ASSOCIATED_PAYMENT_DETAILS(state, val) {
    state.associatedPaymentDetails = val;
  },

  UPDATE_OTP_VALUE(state, val) {
    state.otpValue = val ? val : '';
  },

  UPDATE_OTP_KEY(state, val) {
    state.otpKey = val ? val : '';
  },

  UPDATE_ACTIVE_MERCHANT(state, val) {
    state.activeMerchant = val;
    state.fiatPayoutBalances = [];
    state.fiatPayoutList = {
      data: [],
      pagination: {
        page: 1,
        perPage: 100,
        total: 0,
      },
    };
    state.fiatPayoutMetaData = null;
  },

  UPDATE_APPROVERS(state, approvers) {
    state.approvers = approvers;
  },

  UPDATE_APPROVAL_TOTAL(state, approvalTotal) {
    state.approvalTotal = approvalTotal;
  },

  UPDATE_MERCHANT_DEPOSITS(state, deposits) {
    state.deposits = deposits;
  },

  UPDATE_MERCHANT_DEPOSITS_METADATA(state, depositMetaData) {
    state.depositMetaData = depositMetaData;
  },

  UPDATE_ENTITY_ADMIN_2FA_TYPE(state, val) {
    state.entityAdmin2FAType = val;
  },

  UPDATE_MERCHANT_FIAT_PAYOUT_CONFIG(state, val) {
    state.activeMerchant.fiat_merchant_config = val;
  },
};

export default mutations;
